import { getTemplateParts } from "@/pages/templates/repositories/TemplatesRepositorie";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { get } from "lodash-es";

type Props = {
	setIsTemplatePartsLoading: (isLoading: boolean) => void;
	setTemplatePartsError: (err: string) => void;
	TemplateId: number | null;
};

export const useSearchTemplateParts = ({
	TemplateId,
	setIsTemplatePartsLoading,
	setTemplatePartsError,
}: Props) => {
	const {
		actions: { setTemplatePartsList },
	} = useTemplatesContext();

	return async () => {
		setTemplatePartsList([]);
		setIsTemplatePartsLoading(true);
		const res = await getTemplateParts(TemplateId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setTemplatePartsList(rowsSource);
			setIsTemplatePartsLoading(false);
		} else {
			setIsTemplatePartsLoading(false);
			setTemplatePartsError(res.message);
		}
	};
};
